import { useEffect, useState } from "react";

/** Current time, refreshed every `everyMs` (clocks and countdowns). */
export const useNow = (everyMs = 30_000): number => {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const timer = window.setInterval(() => setNow(Date.now()), everyMs);
    return () => window.clearInterval(timer);
  }, [everyMs]);
  return now;
};
